import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface State {
  expForDevs?: number;
  expName?: string | null;
  expVariant?: string | null;
  expSource?: string | null;
  expError?: string | null;
}

const initialState: State = {
  expForDevs: Number(process.env.EXPERIMENT_FOR_DEVS === '1' ? 1 : 0),
  expName: process.env.EXPERIMENT_NAME_ID || '',
  expVariant: null,
  expSource: null,
  expError: null,
};

const experiment = createSlice({
  name: 'experiment',

  initialState,

  reducers: {
    setExperiment(state, action: PayloadAction<any>) {
      state.expName = action.payload.expName;
      state.expVariant = action.payload.expVariant;
      state.expSource = action.payload.expSource;
      state.expError = action.payload.expError;
    },
  },
});

export const {
  setExperiment,
} = experiment.actions;

export default experiment.reducer;
